// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2OarC","modalFooterButton":"ModalNotes_modalFooterButton__Dur1v"};